import { render, staticRenderFns } from "./MyScroll.vue?vue&type=template&id=25be3055&"
import script from "./MyScroll.vue?vue&type=script&lang=js&"
export * from "./MyScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports